import {HttpService} from './services/http.service';

export class AppConfig {
    public static metaArrayAllPages: any = null;
    public static allTextBlocks: any = null;
    public static siteConfig: any = null;

    public static baseUrl = 'http://ab.usalinksystem.net/';
    public static baseUrlApi = 'http://api.thescarsofsurvival.com/';
    public static instance = null;
    public ob: Promise<any>;
    public static getBlogLink(blog) {
        return '/blog/details/' + blog.title.replace(/\s/g, '-') + '-' + blog.id_article;
    }


    constructor(public http: HttpService) {
    }

    getMetaAllPages(callback) {
        if (AppConfig.metaArrayAllPages !== null) {
            return callback(AppConfig.metaArrayAllPages);
        }
        this.http.get(AppConfig.baseUrlApi + 'meta/api_all_meta').subscribe(response => {
            AppConfig.metaArrayAllPages = response.content;
            callback(response.content);
        }, error => {
            console.log(error);
        });
    }

    getAllTextBlocks(callback) {
        if (AppConfig.allTextBlocks !== null) {
            return callback(AppConfig.allTextBlocks);
        }
        this.http.get(AppConfig.baseUrlApi + 'text_blocks/api_text_blocks').subscribe(response => {
            AppConfig.allTextBlocks = response.content;
            callback(response.content);
        }, error => {
            console.log(error);
        });
    }

    getConfig(callback) {
        if (AppConfig.siteConfig !== null) {
            return callback(AppConfig.siteConfig);
        }
        this.http.get(AppConfig.baseUrlApi + 'configurations/api_configs_all').subscribe(response => {
            AppConfig.siteConfig = response.content;
            callback(response.content);
        }, error => {
            console.log(error);
        });
    }
}



// WEBPACK FOOTER //
// /home3/usalinks/public_html/ally-book-source/src/app/app.config.ts